import { Pipe, PipeTransform } from '@angular/core';
import {BookmarksService} from "../services/bookmarks.service";
import {SynapiItem} from "../models/Synapi/SynapiItem";

@Pipe({
  name: 'isBookmark',
  standalone: true,
  pure : false,
})
export class IsBookmarkPipe implements PipeTransform {

  constructor(public bookmarksService : BookmarksService) {
  }
  transform(item: SynapiItem): boolean {
    return this.bookmarksService.has(item);
  }
}
